import React from 'react';

import { Table, Popconfirm } from 'antd';

import { TableCol } from './getTableCol';

import { planStruct } from './struct';

import { getAsNumber } from '../../../../../../../utilities/numberConvertion';


export const Plan = ({ planing, handlePlaning, status }) => {

  const handleSave = (row) => {
    const currentOutcome = [...planing];
    const index = currentOutcome.findIndex((item) => row.key === item.key);
    const item = currentOutcome[index];

    row.application_type = getAsNumber(row.application_type);

    currentOutcome.splice(index, 1, {
      ...item,
      ...row
    });
    handlePlaning(currentOutcome);
  };

  const handleDelete = (key) => {
    const newData = planing.filter((item) => item.key !== key);
    handlePlaning(newData);
  };

  const columns = [
    ...TableCol(handleSave, status),
    {
      title: 'Action',
      dataIndex: 'operation',
      render: (_, record) => (
        <Popconfirm
          title="Sure to delete?"
          onConfirm={() => handleDelete(record.key)}
          disabled={status === 1 || status === 2 || status === 3}
        >
          <a>Delete</a>
        </Popconfirm>
      )
    }
  ];

  return (
    <>
      <Table {...planStruct.table} columns={columns} dataSource={planing} />
    </>
  );
};
